// extracted by mini-css-extract-plugin
module.exports = {"green":"imageSlider-module--green--2EtLb","bgImage":"imageSlider-module--bgImage--2o_3b","btn":"imageSlider-module--btn--o1Prz"};